// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import PermissionSystemConfiguration from './PermissionBody/Izenda.PermissionSystemConfiguration';
import PermissionTenantSetup from './PermissionBody/Izenda.PermissionTenantSetup';
import PermissionDataSetup from './PermissionBody/Izenda.PermissionDataSetup';
import PermissionUserSetup from './PermissionBody/Izenda.PermissionUserSetup';
import PermissionRoleSetup from './PermissionBody/Izenda.PermissionRoleSetup';
import PermissionReports from './PermissionBody/Izenda.PermissionReports';
import PermissionDashboards from './PermissionBody/Izenda.PermissionDashboards';
import PermissionAccess from './PermissionBody/Izenda.PermissionAccess';
import PermissionScheduling from './PermissionBody/Izenda.PermissionScheduling';
import PermissionEmailing from './PermissionBody/Izenda.PermissionEmailing';
import PermissionExporting from './PermissionBody/Izenda.PermissionExporting';
import PermissionSystemWide from './PermissionBody/Izenda.PermissionSystemWide';
import PermissionFullReportDashboardAccess from './PermissionBody/Izenda.PermissionFullReportDashboardAccess';
import CheckboxAllPermission from './PermissionBody/Izenda.CheckboxAllPermission';
import { pick } from 'lodash/fp';

function PermissionBody(props: Object) {
  const {
    permissionStore,
    permissionStore: { model: permission, tenantDetail },
    accessStore,
    readOnly,
    disabledTab,
    isTemplatePermissions
  } = props;

  /**
   * render component
   * @return {Object} component
   */

  const commonProps = { permission, permissionStore, readOnly, isTemplatePermissions };

  return (
    <div className='izenda-Wrapper-content'>
      <ScrollBox>
        <fieldset disabled={disabledTab}>
          <CheckboxAllPermission
            selectAllPermimssion
            permission={permission}
            readOnly={readOnly}
            disabled={isTemplatePermissions}
            section={permission}
            tenantPermission={tenantDetail}
            tenantDetail={tenantDetail}
          />
          <PermissionFullReportDashboardAccess {...commonProps} />
          <PermissionSystemConfiguration {...commonProps} />
          <PermissionTenantSetup {...commonProps} />
          <PermissionDataSetup {...commonProps} />
          <PermissionUserSetup {...commonProps} />
          <PermissionRoleSetup {...commonProps} />
          <PermissionReports {...commonProps} />
          <PermissionDashboards {...commonProps} />
          <PermissionAccess {...commonProps} accessStore={accessStore} />
          <PermissionScheduling {...commonProps} />
          <PermissionEmailing {...commonProps} />
          <PermissionExporting {...commonProps} />
          <PermissionSystemWide {...commonProps} />
        </fieldset>
      </ScrollBox>
    </div>
  );
}

PermissionBody.propTypes = {
  permissionStore: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};

export default connect()(PermissionBody);



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/Izenda.PermissionBody.jsx